module.exports = __webpack_public_path__ + "static/media/36.bfed4d81.mp3";